import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";
import { Link } from "react-router-dom";

const EquityCommodityTrading = () => {
  useEffect(() => {
    if (window.jQuery && window.$.fn.tab) {
      window.$(".tab1").tab();
      window.$(".tab2").tab({ trigger_event_type: "mouseover" });
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="equity-commodity-page">
      <SEO
        title="Equity & Commodity Trading"
        description="Seamless trading in equities and commodities with expert market insights and execution. Access NSE, BSE, and MCX with market-leading platforms."
      />

      <section className="service-banner">
        <img
          src="/images/banners/equity-banner.avif"
          alt="Equity & Commodity Trading Banner"
          loading="eager"
          id="service-desktop-banner"
        />
        <img
          src="/images/banners/equity-mobile-banner.avif"
          alt="Equity & Commodity Trading Mobile Banner"
          loading="eager"
          id="service-mobile-banner"
        />
        <div className="services-banner-content">
          <h1 data-aos="fade-up">
            Equity & Commodity <span>Trading</span>
          </h1>
          <div className="banner-highlights" data-aos="fade">
            <span>Invest</span>
            <span>Grow</span>
            <span>Secure</span>
          </div>
        </div>
      </section>

      <section className="offered-services">
        <div className="container">
          <div className="offered-services-left">
            <h2 data-aos="fade-up">
              <span>What</span> <br /> We Offer
            </h2>
            <p>
              Participate in India’s dynamic capital and commodity markets
              through our integrated trading ecosystem designed for precision,
              transparency, and performance. We provide access to equities,
              equity derivatives (Futures & Options), and commodity derivatives
              across major exchanges, supported by robust technology
              infrastructure and disciplined risk management practices.
            </p>
            <p>
              Our trading framework is built to serve a wide spectrum of market
              participants — from long-term investors building diversified
              portfolios to active traders executing short-term strategies. With
              seamless order execution, real-time market intelligence, and
              structured research support, we enable informed participation
              aligned with individual risk profiles and financial objectives.
            </p>
          </div>
          <div className="offered-services-right">
            <img
              src="/images/services/equity-offer.avif"
              alt="Equity and Commodity Trading Platform Overview"
              loading="lazy"
            />
          </div>
        </div>

        <img
          src="/images/services/offer-bg.avif"
          alt=""
          className="offer-bg"
          aria-hidden="true"
        />
      </section>

      <section className="services-divider">
        <div className="services-divider-left"></div>
        <div className="services-divider-right"></div>
      </section>

      <section className="services-highlights">
        <div className="container">
          <div className="services-highlights-left">
            <h2 data-aos="fade-up">Key Highlights</h2>
            <p>
              Access markets with confidence through seamless trading platforms
              and real-time insights. Designed for agility, transparency, and
              informed decision-making.
            </p>
            <img
              src="/images/services/equity-highlight.png"
              alt="Equity and Commodity Trading Key Highlights Graphic"
              loading="lazy"
            />
          </div>

          <div className="services-highlights-right">
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Trading in Equity, F&O & Commodities</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Advanced charting & market analytics</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Research-backed insights</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Efficient order execution systems</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Dedicated relationship support</p>
            </div>
          </div>
        </div>
      </section>

      <section className="services-disclaimer">
        <div className="container">
          <p>
            <b>Disclaimer</b>: Investments in securities markets are subject to
            market risks. Derivatives and commodities trading involve high risk
            and may not be suitable for all investors. Please evaluate your risk
            appetite before investing.
          </p>
        </div>
      </section>

      <section className="services-app-download">
        <div className="container">
          <div className="services-app-download-left">
            <img
              src="/images/download.avif"
              alt="Investment Mobile App Preview"
              loading="lazy"
            />
          </div>
          <div className="services-app-download-right">
            <h3 data-aos="fade-up">
              Download Our <br /> Investment Fund App
            </h3>
            <p>Investing With Gateway Financial Services Limited</p>
            <Link to="/" className="download-btn lm-btn">
              Download Now
            </Link>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default EquityCommodityTrading;
